/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { encodeBase64 } from "../../utils/utilityFunctions"
import { HoldingsTableData } from "../../components/investorOverview/mutualFund/holdings/types"
import { CALL_API } from "../middleware"
import { GetInvestorInfoBody } from "../types/api-types"
import {
    AmcFilter,
    AppliedFundsFilters,
    CategoryFilter,
    GET_AMC_FILTERS,
    GET_AMC_FILTERS_SUCCESS,
    GET_CATEGORY_FILTERS,
    GET_CATEGORY_FILTERS_SUCCESS,
    GET_INDIVIDUAL_FUND,
    GET_INDIVIDUAL_FUND_SUCCESS,
    GET_RISK_FILTERS,
    GET_RISK_FILTERS_SUCCESS,
    GET_SCHEMES_TABLE_DATA,
    GET_SCHEMES_TABLE_DATA_SUCCESS,
    GET_SEARCH_SCHEMES_TABLE_DATA,
    GET_SEARCH_SCHEMES_TABLE_DATA_SUCCESS,
    GetIndividualFundDetailsResponseBody,
    GetSchemesTableDataRequestBody,
    GetSchemesTableDataResponseBody,
    GetSearchSchemesTableDataRequestBody,
    GetSearchSchemesTableDataResponseBody,
    RiskFilter,
    SET_APPLIED_FUNDS_FILTERS,
    SET_SELECTED_SCHEMES,
    SelectedSchemesObj,
    SchemeID,
    GET_HISTORICAL_NAV,
    GET_HISTORICAL_NAV_SUCCESS,
    GetHistoricalNavResponseBody,
    ClientCode,
    GetMandateCreationDetailsResponseBody,
    GET_MANDATE_DETAIL_SUCCESS,
    GET_MANDATE_DETAIL,
    RegisterMandateRequestBody,
    GET_MANDATE_REGISTERED_SUCCESS,
    GET_MANDATE_REGISTERED,
    GetMandateRegisteredResponseBody,
    GetMandatesListRequestBody,
    MandatesListResBody,
    FileID,
    GET_MANDATE_LIST_SUCCESS,
    GET_MANDATE_LIST,
    DOWNLOAD_FORM_SUCCESS,
    DOWNLOAD_FORM,
    DownloadFormRes,
    ProceedMandateFormBody,
    ProceedMandateFormRes,
    PROCEED_MANDATE_FORM_SUCCESS,
    PROCEED_MANDATE_FORM,
    GET_STATUS_FILTERS_SUCCESS,
    GET_STATUS_FILTERS,
    StatusFilter,
    AppliedRecommendationsFilters,
    SET_APPLIED_RECOMMENDATIONS_FILTERS,
    RecommendationsActiveCategories,
    SET_RECOMMENDATIONS_ACTIVE_CATEGORIES,
    GetRecommendationsDataRequestBody,
    GetRecommendationsDataResponseBody,
    GET_RECOMMENDATIONS_DATA_SUCCESS,
    GET_RECOMMENDATIONS_DATA,
    GET_INVESTOR_DETAIL_SUCCESS,
    GET_INVESTOR_DETAIL,
    GET_APPLICATION_DATA_SUCCESS,
    GET_APPLICATION_DATA,
    CLIENTCODE,
    SET_EXPLORE_MUTUAL_FUNDS_PAGE_VISITED,
    LatestRecommendationDataRes,
    LatestRecommendationDataBody,
    LatestNotificationsRes,
    LatestNotificationsBody,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS,
    InvestorInfoRes,
    InvestorAllocationBody,
    InvestorAllocationRes,
    GET_INVESTOR_INFO_SUCCESS,
    GET_INVESTOR_INFO,
    GET_INVESTOR_ALLOCATION_SUCCESS,
    GET_INVESTOR_ALLOCATION,
    GetMandateCreationDetailsReq,
    GET_AOF_FORM,
    GET_AOF_FORM_SUCCESS,
    SET_APPLIED_HOLDINGS_FILTERS,
    SET_HOLDINGS_ACTIVE_CATEGORY,
    SET_SELECTED_HOLDINGS_IDS,
    AppliedHoldingsFilters,
    GET_HOLDINGS_DATA_SUCCESS,
    GET_HOLDINGS_DATA,
    GetHoldingsDataRequestBody,
    GetHoldingsDataResponseBody,
    CHECK_SELECTED_HOLDING_SCHEMES,
    SET_SELECTED_HOLDINGS_INFO,
    SET_ALL_SELECTED_HOLDINGS_INFO,
    GetFamilyDetailsRequestBody,
    GetFamilyDetailsResponseBody,
    GET_FAMILY_DETAILS_SUCCESS,
    GET_FAMILY_DETAILS,
    SET_SYSTEMATIC_PLANS_SEARCH_TEXT,
    AppliedSystematicPlansFilter,
    SET_APPLIED_SYSTEMATIC_PLANS_FILTERS,
    GET_REASONS_FOR_SIP_CANCELLATION_SUCCESS,
    GET_REASONS_FOR_SIP_CANCELLATION,
    GET_SYSTEMATIC_PLANS_TABLE_DATA_SUCCESS,
    GET_SYSTEMATIC_PLANS_TABLE_DATA,
    GetSystematicPlansTableDataRequestBody,
    GetSystematicPlansTableDataResponseBody,
    PAUSE_SIP_TRANSACTION_SUCCESS,
    PAUSE_SIP_TRANSACTION,
    PauseSipTransactionRequestBody,
    PauseSipTransactionResponseBody,
    CANCEL_SIP_TRANSACTION_SUCCESS,
    CANCEL_SIP_TRANSACTION,
    CancelSipTransactionRequestBody,
    CancelSipTransactionResponseBody,
    CANCEL_SWP_TRANSACTION_SUCCESS,
    CANCEL_SWP_TRANSACTION,
    CancelSwpTransactionRequestBody,
    CancelSwpTransactionResponseBody,
    GET_SYSTEMATIC_PLANS_STATUS_FILTER_SUCCESS,
    GET_SYSTEMATIC_PLANS_STATUS_FILTER,
    CancelStpTransactionRequestBody,
    CANCEL_STP_TRANSACTION_SUCCESS,
    CANCEL_STP_TRANSACTION,
    CancelStpTransactionResponseBody,
    UPDATE_BSE_FLAG_SUCCESS,
    UPDATE_BSE_FLAG,
    RenewedPauseSipTransactionReqBody,
    REN_PAUSE_SIP_TRANSACTION_SUCCESS,
    REN_PAUSE_SIP_TRANSACTION,
    RenCancelSipTransactionReqBody,
    RenCancelStpTransactionReqBody,
    REN_CANCEL_SIP_TRANSACTION_SUCCESS,
    REN_CANCEL_SIP_TRANSACTION,
    REN_CANCEL_STP_TRANSACTION_SUCCESS,
    REN_CANCEL_STP_TRANSACTION,
    GetPortfolioXirrRequestBody,
    GetPortfolioXirrResponseBody,
    GET_PORTFOLIO_XIRR_SUCCESS,
    GET_PORTFOLIO_XIRR,
    GetPopularFundsRes,
    GET_POPULAR_FUNDS_SUCCESS,
    GET_POPULAR_FUNDS,
    GET_EXPLORE_MF_CATEGORIES_SUCCESS,
    GET_EXPLORE_MF_CATEGORIES,
} from "../types/investorProfile"

export const getAmcFilters = () => async (dispatch: any): Promise<AmcFilter[]> => {
    return await dispatch({
        [CALL_API]: {
            url: `/onboarding/transactions/mutual-funds/amc`,
            method: 'POST',
            enableFixture: false,
            json: 'amc-filters.json',
            types: [GET_AMC_FILTERS_SUCCESS, GET_AMC_FILTERS]
        }
    })
}

export const getCategoryFilters = () => async (dispatch: any): Promise<CategoryFilter[]> => {
    return await dispatch({
        [CALL_API]: {
            url: `/onboarding/transactions/mutual-funds/category`,
            method: 'POST',
            enableFixture: false,
            json: 'category-filters.json',
            types: [GET_CATEGORY_FILTERS_SUCCESS, GET_CATEGORY_FILTERS]
        }
    })
}

export const getRiskFilters = () => async (dispatch: any): Promise<RiskFilter[]> => {
    return await dispatch({
        [CALL_API]: {
            url: `/onboarding/transactions/mutual-funds/risk_type`,
            method: 'POST',
            enableFixture: false,
            json: 'risk-filters.json',
            types: [GET_RISK_FILTERS_SUCCESS, GET_RISK_FILTERS]
        }
    })
}

export const getPopularFunds =
    () =>
        async (dispatch: any): Promise<GetPopularFundsRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/mutual-funds/popular_funds`,
                    method: 'POST',
                    types: [GET_POPULAR_FUNDS_SUCCESS, GET_POPULAR_FUNDS]
                }
            })
        }

export const getExploreMFCategories =
    () =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/mutual-funds/popular_categories`,
                    method: 'POST',
                    types: [GET_EXPLORE_MF_CATEGORIES_SUCCESS, GET_EXPLORE_MF_CATEGORIES]
                }
            })
        }


export const getSchemesTableData =
    (body: GetSchemesTableDataRequestBody) =>
        async (dispatch: any): Promise<GetSchemesTableDataResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/mutual-funds/funds`,
                    method: 'POST',
                    types: [GET_SCHEMES_TABLE_DATA_SUCCESS, GET_SCHEMES_TABLE_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const getSearchSchemesTableData =
    (body: GetSearchSchemesTableDataRequestBody) =>
        async (dispatch: any): Promise<GetSearchSchemesTableDataResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/search/schemes`,
                    method: 'POST',
                    types: [GET_SEARCH_SCHEMES_TABLE_DATA_SUCCESS, GET_SEARCH_SCHEMES_TABLE_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const setAppliedFundsFilters =
    (appliedFundsFilters: AppliedFundsFilters[]): { type: string; appliedFundsFilters: AppliedFundsFilters[] } => {
        return {
            type: SET_APPLIED_FUNDS_FILTERS,
            appliedFundsFilters,
        };
    };

export const setSelectedSchemesObj =
    (selectedSchemesObj: SelectedSchemesObj): { type: string; selectedSchemesObj: SelectedSchemesObj } => {
        return {
            type: SET_SELECTED_SCHEMES,
            selectedSchemesObj,
        };
    };


export const getIndividualFundDetails =
    (body: SchemeID) =>
        async (dispatch: any): Promise<GetIndividualFundDetailsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/individualFund`,
                    method: 'POST',
                    types: [GET_INDIVIDUAL_FUND_SUCCESS, GET_INDIVIDUAL_FUND],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        }

export const getHistoricalNavDetails =
    (body: SchemeID) =>
        async (dispatch: any): Promise<GetHistoricalNavResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/historicalNav`,
                    method: 'POST',
                    types: [GET_HISTORICAL_NAV_SUCCESS, GET_HISTORICAL_NAV],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        }

export const getMandateCreationDetails =
    (body: GetMandateCreationDetailsReq) =>
        async (dispatch: any): Promise<GetMandateCreationDetailsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/applications/bankDetails`,
                    method: 'POST',
                    types: [GET_MANDATE_DETAIL_SUCCESS, GET_MANDATE_DETAIL],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        }

export const getMandateRegistered =
    (body: RegisterMandateRequestBody) =>
        async (dispatch: any): Promise<GetMandateRegisteredResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/register-mandate`,
                    method: 'POST',
                    types: [GET_MANDATE_REGISTERED_SUCCESS, GET_MANDATE_REGISTERED],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        }


export const getMandatesList =
    (body: GetMandatesListRequestBody) =>
        async (dispatch: any): Promise<Array<MandatesListResBody>> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/mandatesList`,
                    method: 'POST',
                    types: [GET_MANDATE_LIST_SUCCESS, GET_MANDATE_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        }


export const downloadMandateForm =
    (body: FileID) =>
        async (dispatch: any): Promise<DownloadFormRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/downloadMandateForm`,
                    method: 'POST',
                    types: [DOWNLOAD_FORM_SUCCESS, DOWNLOAD_FORM],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        }


export const proceedMandateForm =
    (body: ProceedMandateFormBody) =>
        async (dispatch: any): Promise<ProceedMandateFormRes> => {
            console.log("BODY Register mandate", body);
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/uploadMandateForm`,
                    method: 'POST',
                    types: [PROCEED_MANDATE_FORM_SUCCESS, PROCEED_MANDATE_FORM],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        }
export const getStatusFilters = () => async (dispatch: any): Promise<StatusFilter[]> => {
    return await dispatch({
        [CALL_API]: {
            url: `/onboarding/transactions/recommendationStatus`,
            method: 'POST',
            types: [GET_STATUS_FILTERS_SUCCESS, GET_STATUS_FILTERS]
        }
    })
}

export const setAppliedRecommendationsFilters =
    (appliedRecommendationsFilters: AppliedRecommendationsFilters[]): { type: string; appliedRecommendationsFilters: AppliedRecommendationsFilters[] } => {
        return {
            type: SET_APPLIED_RECOMMENDATIONS_FILTERS,
            appliedRecommendationsFilters,
        };
    };

export const setRecommendationsActiveCategories =
    (recommendationsActiveCategories: RecommendationsActiveCategories): { type: string; recommendationsActiveCategories: RecommendationsActiveCategories } => {
        return {
            type: SET_RECOMMENDATIONS_ACTIVE_CATEGORIES,
            recommendationsActiveCategories,
        };
    };

export const setClientCode =
    (clientCode: string): { type: string; clientCode: string } => {
        return {
            type: CLIENTCODE,
            clientCode,
        };
    };

export const getRecommendationsData =
    (body: GetRecommendationsDataRequestBody) =>
        async (dispatch: any): Promise<GetRecommendationsDataResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/recommendations`,
                    method: 'POST',
                    types: [GET_RECOMMENDATIONS_DATA_SUCCESS, GET_RECOMMENDATIONS_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getInvestorDetails =
    () =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/dashboard/getInvestorDetails',
                    method: 'GET',
                    types: [GET_INVESTOR_DETAIL_SUCCESS, GET_INVESTOR_DETAIL],
                },
            });
        };


export const getApplicationDetailsByClientCode =
    (body: ClientCode) =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/applications/getApplictionByClientcode`,
                    method: 'POST',
                    types: [GET_APPLICATION_DATA_SUCCESS, GET_APPLICATION_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const updateBSEFlag =
    (body: { applicationId: string | number, isBSEEnabled: boolean }) =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/applications/updateBSEFlag`,
                    method: 'POST',
                    types: [UPDATE_BSE_FLAG_SUCCESS, UPDATE_BSE_FLAG],
                    body
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
export const setExploreMutualFundsPageVisited =
    (isExploreMutualFundsPageVisited: boolean): { type: string; isExploreMutualFundsPageVisited: boolean } => {
        return {
            type: SET_EXPLORE_MUTUAL_FUNDS_PAGE_VISITED,
            isExploreMutualFundsPageVisited,
        };
    };


export const getLatestRecommendations =
    (body: LatestRecommendationDataBody) =>
        async (dispatch: any): Promise<LatestRecommendationDataRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/getLatestRecommendationsData`,
                    method: 'POST',
                    types: [GET_APPLICATION_DATA_SUCCESS, GET_APPLICATION_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getLatestNotifications =
    (body: LatestNotificationsBody) =>
        async (dispatch: any): Promise<LatestNotificationsRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/get-notifications`,
                    method: 'POST',
                    types: [GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const getInvestorInfo =
    (body: GetInvestorInfoBody) =>
        async (dispatch: any): Promise<InvestorInfoRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/getApplicationForInvestorDetails`,
                    method: 'POST',
                    types: [GET_INVESTOR_INFO_SUCCESS, GET_INVESTOR_INFO],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const getInvestorAllocation =
    (body: InvestorAllocationBody) =>
        async (dispatch: any): Promise<InvestorAllocationRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/getInvestorAssestAllocation`,
                    method: 'POST',
                    types: [GET_INVESTOR_ALLOCATION_SUCCESS, GET_INVESTOR_ALLOCATION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const getAofFrom =
    (body: { clientCode: string }) =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/downloadAofForm`,
                    method: 'POST',
                    types: [GET_AOF_FORM_SUCCESS, GET_AOF_FORM],
                    body,
                },
            });
        };

export const setAppliedHoldingsFilters =
    (appliedHoldingsFilters: AppliedHoldingsFilters[]): { type: string; appliedHoldingsFilters: AppliedHoldingsFilters[] } => {
        return {
            type: SET_APPLIED_HOLDINGS_FILTERS,
            appliedHoldingsFilters,
        };
    };

export const setHoldingsActiveCategory =
    (holdingsActiveCategory: string): { type: string; holdingsActiveCategory: string } => {
        return {
            type: SET_HOLDINGS_ACTIVE_CATEGORY,
            holdingsActiveCategory,
        };
    };

export const setSelectedHoldingsIds =
    (selectedHoldingsIds: string[]): { type: string; selectedHoldingsIds: string[] } => {
        return {
            type: SET_SELECTED_HOLDINGS_IDS,
            selectedHoldingsIds,
        };
    };

export const setCheckedHoldingSchemes =
    (checkedHoldingInvestments: string[]): { type: string; checkedHoldingInvestments: string[] } => {
        return {
            type: CHECK_SELECTED_HOLDING_SCHEMES,
            checkedHoldingInvestments,
        };
    };

export const setSelectedHoldingsInfo =
    (selectedHoldingsInfo: Array<{ checkedId: string; schemeId: string; folioNo: string; uniqueId: string; }>): { type: string; selectedHoldingsInfo: Array<{ checkedId: string; schemeId: string; folioNo: string; uniqueId: string; }> } => {
        // console.log("Actuion", selectedHoldingsInfo)
        return {
            type: SET_SELECTED_HOLDINGS_INFO,
            selectedHoldingsInfo,
        };
    };
export const setSelectedAllHoldingsInfo =
    (selectAllHoldingsInfo: HoldingsTableData[]): { type: string; selectAllHoldingsInfo: HoldingsTableData[] } => {
        return {
            type: SET_ALL_SELECTED_HOLDINGS_INFO,
            selectAllHoldingsInfo,
        };
    };

export const getHoldingsData =
    (body: GetHoldingsDataRequestBody) =>
        async (dispatch: any): Promise<GetHoldingsDataResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/investorHoldings`,
                    method: 'POST',
                    types: [GET_HOLDINGS_DATA_SUCCESS, GET_HOLDINGS_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getFamilyDetails =
    (body: GetFamilyDetailsRequestBody) =>
        async (dispatch: any): Promise<GetFamilyDetailsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/family-details`,
                    method: 'POST',
                    types: [GET_FAMILY_DETAILS_SUCCESS, GET_FAMILY_DETAILS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const setSystematicPlansSearchText =
    (systematicPlansSearchText: string): { type: string; systematicPlansSearchText: string } => {
        return {
            type: SET_SYSTEMATIC_PLANS_SEARCH_TEXT,
            systematicPlansSearchText,
        };
    };

export const setAppliedSystematicPlansFilters =
    (appliedSystematicPlansFilters: AppliedSystematicPlansFilter[]): { type: string; appliedSystematicPlansFilters: AppliedSystematicPlansFilter[] } => {
        return {
            type: SET_APPLIED_SYSTEMATIC_PLANS_FILTERS,
            appliedSystematicPlansFilters,
        };
    };

export const getReasonsForSipCancellation =
    () =>
        async (dispatch: any): Promise<{
            code: string;
            description: string;
        }[]> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/xsip-cancellation-reasons-list',
                    method: 'GET',
                    types: [GET_REASONS_FOR_SIP_CANCELLATION_SUCCESS, GET_REASONS_FOR_SIP_CANCELLATION],
                },
            });
        };

export const getSystematicPlansTableData =
    (body: GetSystematicPlansTableDataRequestBody) =>
        async (dispatch: any): Promise<GetSystematicPlansTableDataResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/get-systematic-plans`,
                    method: 'POST',
                    types: [GET_SYSTEMATIC_PLANS_TABLE_DATA_SUCCESS, GET_SYSTEMATIC_PLANS_TABLE_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const pauseSipTransaction =
    (body: PauseSipTransactionRequestBody) =>
        async (dispatch: any): Promise<PauseSipTransactionResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/pause-xsip`,
                    method: 'POST',
                    types: [PAUSE_SIP_TRANSACTION_SUCCESS, PAUSE_SIP_TRANSACTION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const renewedPauseSipTransaction =
    (body: RenewedPauseSipTransactionReqBody) =>
        async (dispatch: any): Promise<PauseSipTransactionResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/pause-xsip`,
                    method: 'POST',
                    types: [REN_PAUSE_SIP_TRANSACTION_SUCCESS, REN_PAUSE_SIP_TRANSACTION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const cancelSipTransaction =
    (body: CancelSipTransactionRequestBody) =>
        async (dispatch: any): Promise<CancelSipTransactionResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/cancel-xsip`,
                    method: 'POST',
                    types: [CANCEL_SIP_TRANSACTION_SUCCESS, CANCEL_SIP_TRANSACTION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const renewedCancelSipTransaction =
    (body: RenCancelSipTransactionReqBody) =>
        async (dispatch: any): Promise<CancelSipTransactionResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/cancel-xsip`,
                    method: 'POST',
                    types: [REN_CANCEL_SIP_TRANSACTION_SUCCESS, REN_CANCEL_SIP_TRANSACTION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const cancelStpTransaction =
    (body: CancelStpTransactionRequestBody) =>
        async (dispatch: any): Promise<CancelStpTransactionResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/cancel-stp`,
                    method: 'POST',
                    types: [CANCEL_STP_TRANSACTION_SUCCESS, CANCEL_STP_TRANSACTION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const renewedCancelStpTransaction =
    (body: RenCancelStpTransactionReqBody) =>
        async (dispatch: any): Promise<CancelStpTransactionResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/cancel-stp`,
                    method: 'POST',
                    types: [REN_CANCEL_STP_TRANSACTION_SUCCESS, REN_CANCEL_STP_TRANSACTION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const cancelSwpTransaction =
    (body: CancelSwpTransactionRequestBody) =>
        async (dispatch: any): Promise<CancelSwpTransactionResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/cancel-swp`,
                    method: 'POST',
                    types: [CANCEL_SWP_TRANSACTION_SUCCESS, CANCEL_SWP_TRANSACTION],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getSystematicPlansStatusFilter =
    () =>
        async (dispatch: any): Promise<{
            code: string;
            description: string;
        }[]> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/transactions/get-systematic-plans-status-filter',
                    method: 'GET',
                    types: [GET_SYSTEMATIC_PLANS_STATUS_FILTER_SUCCESS, GET_SYSTEMATIC_PLANS_STATUS_FILTER],
                },
            });
        };

export const getPortfolioXirr =
    (body: GetPortfolioXirrRequestBody) =>
        async (dispatch: any): Promise<GetPortfolioXirrResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/portfolioXirr`,
                    method: 'POST',
                    types: [GET_PORTFOLIO_XIRR_SUCCESS, GET_PORTFOLIO_XIRR],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


